import { render, staticRenderFns } from "./block-money-transfer.vue?vue&type=template&id=ddef062a&scoped=true&lang=pug&"
import script from "./block-money-transfer.vue?vue&type=script&lang=js&"
export * from "./block-money-transfer.vue?vue&type=script&lang=js&"
import style0 from "./block-money-transfer.vue?vue&type=style&index=0&id=ddef062a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddef062a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
